<template>
    <div>
        <div class="page-title">Email Setup</div>
        <div class="page-box">

        <el-form :label-position="labelPosition" label-width="180px" :model="formLabelAlign">
            <template v-for="(item,index) in formLabelAlign.emailAccounts "> 
                <el-form-item :key="index + 'E-mail from address'" :label="`E-mail from address${index+1}`">
                    <el-input v-model="item.account"></el-input>
                    <div>The e-mail address that all e-mails will be from.</div>
                </el-form-item>
                <el-form-item :key="index + 'password'" label="E-mail from password">
                    <el-input v-model="item.password"></el-input>
                    <div>The address of your outgoing SMTP server.</div>
                </el-form-item>
                <el-form-item :key="index + 'SMTP Server'" label="SMTP Server">
                    <el-input v-model="item.smtpHost"></el-input>
                    <div>The address of your outgoing SMTP server.</div>
                </el-form-item>
                <el-form-item :key="index + 'SMTP Port'" label="SMTP Port">
                    <el-input v-model="item.smtpPort"></el-input>
                    <div>The default SMTP port is 25, if that is being blocked try 80. Gmail uses 465. See http://gmail.google.com/support/bin/answer.py?answer=13287 for more information on configuring for use with Gmail.</div>
                </el-form-item>
                <el-form-item :key="index + 'Priority'" label="Priority">
                   
                      <el-select v-model="item.priority" placeholder="請选择">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                </el-form-item>
                <el-form-item :key="index + 'delete'">
                    <el-button @click="onDelete(index)" type="warning">delete</el-button>
                </el-form-item>
            </template>
            <div style="margin:20px;">
              <el-button @click="onAdd" type="warning">add</el-button>
              
            </div>
            <el-button @click="onConfirm" type="warning">Submit</el-button>
            <el-button @click="onCancel">Cancel</el-button>
        </el-form>
        </div>
    </div>
</template>

<script>
    import {getEmailAccounts,addEmailAccount} from '@/api/admin/setting'
    export default {
        data() {
            return {
                options:[
                    {
                        label:'represent enable',
                        value:0,
                    },
                    {
                        label:'represent disable',
                        value:1,
                    },
                ],
                formLabelAlign: {
                    emailAccounts:[
                        {
                            smtpHost: null, 
                            smtpPort: null, 
                            account: null, 
                            password: null, 
                            priority: null
                        }
                    ],
                }
            }
        },
        created(){
            this.getEmailAccounts()
        },
        methods:{
            onDelete(index){
                this.formLabelAlign.emailAccounts.splice(index, 1); 
            },
            onAdd(){
                let newEmailAccounts ={
                        smtpHost: null, 
                        smtpPort: null, 
                        account: null, 
                        password: null, 
                        priority: null
                }
              this.formLabelAlign.emailAccounts.push(newEmailAccounts)
            },
            onConfirm(){
                this.addEmailAccount()
            },
            onCancel(){},
            getEmailAccounts(){
                getEmailAccounts().then((v)=>{
                     this.formLabelAlign.emailAccounts = v.data
                })
            },
            addEmailAccount(){
                addEmailAccount(this.formLabelAlign.emailAccounts).then(()=>{
                     this.$message.success('Email success')
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.page-box{
    background-color: #fff;
    padding: 30px;
}
</style>